import * as Highcharts from "highcharts";
// chart with 2 lines

export const chartData = {
  credits: { enabled: false },
  chart: {
    type: "column"
  },

  title: {
    text: ""
  },
  legend: {
    itemStyle: {
      color: "#6b778c",
      "font-weight": "normal",

    },
    reversed: true
  },

  xAxis: {
    categories: ["North", "East", "South", "West"]
  },

  yAxis: [
    {
      allowDecimals: false,
      min: 0,
      title: {
        text: "Percentage"
      },
      labels: {
        style: { fontSize: "12px" },
        format: "{value}%"
      }
    }
  ],

  tooltip: {
    pointFormatter: function () {
      return (
        "<b>" +
        this.x +
        "</b><br/>" +
        this.series.name +
        ": " +
        this.y +
        "<br/>" +
        "Total: " +
        this.point.stackTotal +
        "%"
      );
    }
  },

  plotOptions: {
    column: {
      stacking: "normal"
    }
  },

  series: [
    {
      name: "1 day",
      data: [381, 349, 380, 654],
      index: 3,
      // data: [],
      stack: "male",
      color: "#ebc844",
      tooltip: { valueSuffix: "  %" }
    },
    {
      name: "2 day",
      // data: [],
      data: [197, 167, 203, 324],
      index: 2,
      stack: "male",
      color: "#73c8b1",
      tooltip: { valueSuffix: "  %" }
    },
    {
      name: "3 day",
      // data: [],
      data: [184, 182, 177, 330],
      index: 1,
      stack: "male",
      color: "#f58f0e",
      tooltip: { valueSuffix: "  %" }
    },
    {
      name: "> 3 day",
      data: [],
      index: 0,
      stack: "male",
      color: "#00afe3",
      tooltip: { valueSuffix: " %" }
    }
  ]
};
